(function() {
    'use strict';

    angular.module('app').directive('fodbzLabelRequired', FodbzLabelRequiredDirective);
    function FodbzLabelRequiredDirective() {
        return {
            transclude: true,
            scope: {
                fodbzField: '@',
                fodbzResource: '@',
            },
            template: `<fodbz-label fodbz-field="{{fodbzField}}" fodbz-resource="{{fodbzResource}} *">
                <ng-transclude></ng-transclude>
            </fodbz-label>`
        };
    }
})();